module.exports = __webpack_public_path__ + "img/wszg.c1c42778.png";